import { useAuthStore } from "@pasta/front-auth-v2";
import { useAppContextApi } from "../http/app-context.api";
import { useUserPreferencesStore } from "../stores/user-preferences.store";
import { useFileStore } from "../stores/file.store";
import { useLetterFileTagStore } from "../stores/letter-file-tag.store";
import { useLetterFileSavedFluxStore } from "../stores/letter-file-saved-flux.store";
import { useInformationBannerStore } from "@pasta/front-information-banner";
import { useVersionAnnouncementStore } from "../../version-announcement/version-announcement.store";
import { useMassSignatureStore } from "../stores/mass-signature.store";
import { useWopiStore } from "../stores/wopi.store";
import { useSimpleFeatureStore } from "../stores/simple-features.store";
import { sortBy } from "lodash";
import { useLetterFileStore } from "../stores/letter-file.store";

export async function loadAppContext() {
  const client = useAppContextApi();
  const authStore = useAuthStore();
  if (authStore.isAuthenticated) {
    const context = await client.fetchContext();

    const letterFileStore = useLetterFileStore();
    letterFileStore.setBalaWhiteList(context.balaWhiteList);

    const userPreferencesStore = useUserPreferencesStore();
    userPreferencesStore.setMaxActivatedTags(context.maxActivatedTags);
    userPreferencesStore.setPreferences(context.userPreferences);

    const fileStore = useFileStore();
    fileStore.setAccepted(context.accepted);

    const tagsStore = useLetterFileTagStore();
    tagsStore.setList(context.letterFileTags);

    const fluxStore = useLetterFileSavedFluxStore();
    fluxStore.setFluxes(context.savedFlux);

    const informationBannerStore = useInformationBannerStore();
    informationBannerStore.setActive(context.informationBanner);

    const versionStore = useVersionAnnouncementStore();
    versionStore.setList({
      data: context.versions.sort((a, b) => b.id - a.id),
      total: context.versions.length,
      isLastPage: context.versions.length <= 5,
      limit: 5,
      offset: 0,
      page: 1,
    });
    versionStore.setHighestVersion(sortBy(versionStore.list.data, "id").at(-1) || null);

    const massSignatureStore = useMassSignatureStore();
    massSignatureStore.setEnabled(context.massSignature.enabled);
    massSignatureStore.setCurrent(context.massSignature.ongoing);
    massSignatureStore.setMaxInactivity(context.massSignature.maxInactivity);
    massSignatureStore.setMaxLetterFiles(context.massSignature.maxLetterFiles);

    const simpleFeaturesStore = useSimpleFeatureStore();
    simpleFeaturesStore.setPrivateMessageEnabled(
      context.privateMessage?.enabled || false,
      context.privateMessage?.audio || { enabled: false, maxDuration: 0 }
    );
    simpleFeaturesStore.setTmpDisableLinksRefacto(context.tmpDisableLinksRefacto);
    simpleFeaturesStore.setSignaturePosFullResize(context.signaturePosFullResize);
    simpleFeaturesStore.setPadesEnabled(context.pades.enabled);
    simpleFeaturesStore.setPadesWebappCert(context.pades.webappCert);
    simpleFeaturesStore.setFavoriteUsers(context.favoriteUsers);
    simpleFeaturesStore.setDocTrashExpiry(context.docTrashExpiry);
    simpleFeaturesStore.setLinkShortenerEnabled(context.linkShortenerEnabled);
    simpleFeaturesStore.setLinksDuration(context.linksDuration);

    const wopiStore = useWopiStore();
    wopiStore.setEnabled(context.wopi.enabled);
    wopiStore.setK2000Enabled(context.wopi.k2000Enabled);
    wopiStore.setK2000Editables(context.wopi.k2000Editables || {});
    wopiStore.setCollaboraEnabled(context.wopi.collaboraEnabled);
    wopiStore.setCollaboraEditables(context.wopi.collaboraEditables || {});
    wopiStore.setTrustedUrl(context.wopi.trustedUrl || "");
    wopiStore.setDebugLocalIp(context.wopi.debugLocalIp || "");
    wopiStore.setFrameLoadTimeout(context.wopi.frameLoadTimeout || 10_000);
  }
}
